const config = {
  siteTitle: 'Bang Den',
  siteUrl: 'https://bangden.space',
  siteLogo: '/logo.png',
  description:
    'Tutorials, linux, cms, website, programming, dan lainnya.',
}

export default config
